// extracted by mini-css-extract-plugin
export default {"appBar":"CustomLayout_appBar__+TG2F","container":"CustomLayout_container__iibgc","logoContainer":"CustomLayout_logoContainer__p-s-c","logo":"CustomLayout_logo__+MtBD"};